import { createContext, useState } from 'react';

const CustomerPricesContext = createContext();

export const CustomerPricesProvider = ({ children }) => {
	const [view, setView] = useState('rfq-view');
	const [archive, setArchive] = useState(false);
	const [rowdata, setRowData] = useState(null);
	const [dataType, setDataType] = useState('all');

	return (
		<CustomerPricesContext.Provider
			value={{
				view,
				setView,
				archive,
				setArchive,
				rowdata,
				setRowData,
				dataType,
				setDataType,
			}}
		>
			{children}
		</CustomerPricesContext.Provider>
	);
};

export default CustomerPricesContext;
